module.exports = __webpack_public_path__ + "img/empty-state-products.5ebb7d6f.svg";